
    import './styles.scoped.css';
    export default {
  "error-icon-shake-wrapper": "awsui_error-icon-shake-wrapper_14mhv_insi4_5",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_14mhv_insi4_1",
  "error-icon-scale-wrapper": "awsui_error-icon-scale-wrapper_14mhv_insi4_32",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_14mhv_insi4_1",
  "error": "awsui_error_14mhv_insi4_5",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_14mhv_insi4_1",
  "root": "awsui_root_14mhv_insi4_76",
  "label": "awsui_label_14mhv_insi4_87",
  "info": "awsui_info_14mhv_insi4_100",
  "description": "awsui_description_14mhv_insi4_105",
  "constraint": "awsui_constraint_14mhv_insi4_106",
  "hints": "awsui_hints_14mhv_insi4_113",
  "constraint-has-error": "awsui_constraint-has-error_14mhv_insi4_114",
  "secondary-control": "awsui_secondary-control_14mhv_insi4_118",
  "controls": "awsui_controls_14mhv_insi4_122",
  "label-hidden": "awsui_label-hidden_14mhv_insi4_122",
  "control": "awsui_control_14mhv_insi4_122",
  "error__message": "awsui_error__message_14mhv_insi4_141",
  "visually-hidden": "awsui_visually-hidden_14mhv_insi4_145"
};
  